import { RadioSensor } from 'z3k-config';
export function getRadioThermometers(config) {
    return RadioSensor.get.where(config, RadioSensor.isThermometer);
}
export function getRadioRelays(config) {
    return RadioSensor.get.where(config, ({ type }) => type === RadioSensor.Type.RADIO_RELAY);
}
